import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import {
	type AgentManagedReferenceObject,
	getReferenceObjectFromContextIdentifier,
} from '../../../common/referenceObjectAri';
import { getAiManagedObjectWithCache } from '../../ai-managed-object-cache';
import type { CopyPasteMarker, CreateCopyPasteIdentityArgs } from './types';

/** Resolves the current Confluence page/container reference used for new AIMO ownership. */
export const getCurrentReferenceObject = ({
	cloudId,
	contentType,
	getContextIdentifierProvider,
}: CreateCopyPasteIdentityArgs): AgentManagedReferenceObject | undefined => {
	const contextIdentifierProvider = getContextIdentifierProvider?.();
	return getReferenceObjectFromContextIdentifier({
		cloudId,
		contentType,
		contextIdentifierProvider,
		product: contextIdentifierProvider?.product,
	});
};

export const getCurrentReferenceObjectAri = (
	args: CreateCopyPasteIdentityArgs,
): string | undefined => getCurrentReferenceObject(args)?.referenceObjectAri;

/** Falls back to the source AIMO when older clipboard payloads do not include the ARI. */
export const getSourceReferenceObjectAri = async (
	editorView: EditorView,
	marker: CopyPasteMarker,
	localId: string,
): Promise<string | undefined> => {
	if (marker.sourceReferenceObjectAri) {
		return marker.sourceReferenceObjectAri;
	}

	const sourceAimo = await getAiManagedObjectWithCache({
		aimoId: marker.sourceAiManagedObjectId,
		editorView,
		localId,
	});

	return sourceAimo?.referenceObjectAri;
};
